import { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { getSortIndex, getAlphabeticalMacroCategories, getDataView } from "../../../utils/analysisTable/analysisUtils";
import GetMacroCategoryOrder from "../../../utils/GetMacroCategoryOrder";

// ✅ Utility moved outside (no eslint warnings)
const calculateDisabledTabs = (moduleName, productsData, mapping, analysisTypeValue, weightToggle, boxAnalysisTypeSelection) => {
    const dataViewKey = getDataView(analysisTypeValue, weightToggle, boxAnalysisTypeSelection);
    const _disabledTabs = {};
    mapping?.forEach((column) => {
        const macroCategory = column.macroCategory;
        const backendVariables = column?.displayLabels?.map((label) => label.backendVariable);
        let hasData = false;
        if (moduleName === "productPreference") {
            // hasData = productsData.some((product) => backendVariables.includes(product.backendVariable) && product.scores.some((score) => hasScore(score, dataViewKey)));
            productsData?.forEach((product) => {
                const bvExists = column?.displayLabels?.filter((ele) => product.backendVariable.includes(ele.backendVariable));
                if (bvExists?.length > 0) {
                    hasData = product.scores.some((score) => hasScore(score, dataViewKey));
                }
            });
        } else if (moduleName === "fragranceAssociation") {
            hasData = productsData?.some((product) => product?.scores.some((score) => backendVariables?.includes(score.title) && hasScore(score, dataViewKey)));
        } else {
            hasData = productsData?.some((product) => product.scores.some((score) => backendVariables?.includes(score.backendVariable) && hasScore(score, dataViewKey)));
        }
        _disabledTabs[macroCategory] = !hasData;
    });
    return _disabledTabs;
};

const hasScore = (score, dataViewKey) => {
    const keys = dataViewKey.split(",");
    const hasValue = keys.some((key) => score[key] !== null);

    return hasValue;
};

function SkewTabs({ tableData = {}, settings = {}, analysisView = {}, actionStandard = {} }) {
    const { productsSecondaryDataState } = tableData;
    const { activeTab, setActiveTab } = settings;
    const { moduleName, mappings, analysisTypeValue, boxAnalysisTypeSelection } = analysisView;
    const { showActionStandards } = actionStandard;

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    let customOrderMacroCategory = GetMacroCategoryOrder(productCategoryData?.label?.toLowerCase(), moduleName);
    if (moduleName === "justRight" && (isHairCare || isSkinCare)) {
        customOrderMacroCategory = getAlphabeticalMacroCategories(mappings);
    } else if (!customOrderMacroCategory && moduleName !== "claims") {
        customOrderMacroCategory = getAlphabeticalMacroCategories(mappings);
    }

    const tableDataMapping = mappings?.slice().sort((a, b) => getSortIndex(a.macroCategory, customOrderMacroCategory) - getSortIndex(b.macroCategory, customOrderMacroCategory));

    const column1 = tableDataMapping?.map((ele) => ele.macroCategory);

    // const [disabledTabs, setDisabledTabs] = useState({});

    // const hasRequiredData = (productsData, mappingData) => productsData.length && mappingData?.length;
    const disabledTabsStatus = calculateDisabledTabs(moduleName, productsSecondaryDataState, tableDataMapping, analysisTypeValue, weightToggle, boxAnalysisTypeSelection);
    column1?.sort((a, b) => (disabledTabsStatus[a] ? 1 : 0) - (disabledTabsStatus[b] ? 1 : 0));

    useEffect(() => {
        if (moduleName === "fragranceAssociation" || (isHairCare && moduleName === "secondary")) {
            const firstEnabledTab = column1?.find((col) => !disabledTabsStatus[col]);
            if (firstEnabledTab && (!activeTab || disabledTabsStatus[activeTab])) {
                setActiveTab(firstEnabledTab);
            }
        }
    }, [activeTab, column1, disabledTabsStatus, setActiveTab, isHairCare, moduleName]);

    const marginLeft = {
        agreement: "-20px ",
        secondary: "-24px ",
        justRight: "-20px",
    };

    const getTextColor = (isDisabled) => {
        if (isDisabled) return "#ccc";
        return "#FFFFFF";
    };

    const getLiClass = (isActive, isDisabled) => {
        if (isDisabled) return "skew-single-side disabled";
        return isActive ? "skew-single-side enabled active" : "skew-single-side enabled";
    };

    // // Disabled tabs effect
    // useEffect(() => {

    //     setDisabledTabs(_disabledTabs);
    // }, [productsSecondaryDataState, tableDataMapping]);

    // Set default activeTab
    useEffect(() => {
        if (!activeTab && column1?.length > 0) {
            setActiveTab(column1[0]);
        }
    }, [activeTab, column1, setActiveTab]);

    const handleCategoryClick = (categoryName) => {
        setActiveTab(categoryName);
    };

    return (
        <>
            <style>
                {`
          .macroCategoryContainer {
              width: 100%;
              overflow-x: auto;
              white-space: nowrap;
              padding-bottom: 10px;
              margin-bottom: 10px;
              margin-top: 30px;
              margin-left: ${marginLeft[moduleName]};
          }

          ul.macroCategory {
              padding: 0;
              display: inline-flex;
              list-style: none;
              margin: 0;
          }

          ul.macroCategory li {
              transform: skew(150deg);
              padding: 5px 10px;
              flex-shrink: 0;
          }

          ul.macroCategory li a {
              display: block;
              text-decoration: none;
              padding: 12px 20px;
              transform: skew(-150deg);
              color: #FFFFFF;
              font-weight: 600;
              letter-spacing: 0.4px;
              font-size: 14px;
          }

          .active,
          li.enabled:hover {
              color: #ffffff !important;
              background: linear-gradient(90deg, rgba(71, 163, 255, 0.999) 0%, rgba(0, 94, 239, 1) 100%) !important;
          }

          .skew-single-side {
              padding-left: 16px;
              margin-left: -16px;
          }

          .scale-info {
              display: inline-block;
              transform: skew(170deg) !important;
              padding: 12px 20px;
              margin-left: 20px;
              color: #000;
              font-weight: normal;
              flex-shrink: 0;
          }
        `}
            </style>

            <div className="macroCategoryContainer">
                <ul className="macroCategory">
                    {column1?.map((col, i) => {
                        const isDisabled = disabledTabsStatus[col] || false;
                        const isActive = activeTab === col;
                        const textColor = getTextColor(isDisabled);
                        const liClass = getLiClass(isActive, isDisabled);
                        const liKey = i + 1;

                        return (
                            <li
                                key={liKey}
                                className={liClass}
                                style={{
                                    background: isDisabled ? "#C9CCCD" : "#82BFFF",
                                    border: isDisabled ? "1px solid #969797" : "1px solid #2F6FB2",
                                    opacity: 1,
                                    pointerEvents: isDisabled ? "none" : "auto",
                                    position: "relative",
                                }}
                            >
                                <span title={isDisabled ? "No data present" : ""}>
                                    <Link
                                        onClick={() => !isDisabled && handleCategoryClick(col)}
                                        // className={isActive ? "active" : ""}
                                        style={{
                                            cursor: isDisabled ? "default" : "pointer",
                                            color: isDisabled ? "#999" : textColor,
                                            pointerEvents: "auto", // allow tooltip on disabled
                                        }}
                                    >
                                        {col}
                                        {showActionStandards && isActive ? "*" : ""}
                                    </Link>
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </>
    );
}

SkewTabs.propTypes = {
    tableData: PropTypes.object,
    settings: PropTypes.object,
    analysisView: PropTypes.object,
    actionStandard: PropTypes.object,
};

export default SkewTabs;
